import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { AlertTriangle, Phone } from "lucide-react";

export default function PartOverdue() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders/overdue").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Part Overdue" subtitle="Order melewati ETD dan belum diterima lengkap." />
      {loading ? <Spinner /> : rows.length === 0 ? <EmptyState title="Tidak ada part overdue" icon={AlertTriangle} /> : (
        <div className="grid gap-2">
          {rows.map((o) => (
            <Card key={o.id} className="p-3 flex items-center justify-between gap-2" data-testid={`overdue-${o.id}`}>
              <div>
                <div className="font-mono-data font-semibold">{o.nopol} • {o.part_number}</div>
                <div className="text-sm text-gray-600">{o.part_name}</div>
                <div className="text-xs text-gray-400 flex flex-wrap gap-x-3 mt-0.5">
                  <span>{o.supplier_name || "—"}</span>
                  {o.supplier_phone && <a href={`tel:${o.supplier_phone}`} className="text-blue-600 flex items-center gap-1"><Phone size={11} />{o.supplier_phone}</a>}
                  <span>ETD {o.etd}</span><span>Ordered {o.qty_to_order} • Received {o.received_qty}</span>
                </div>
              </div>
              <div className="text-right">
                <StatusBadge status="OVERDUE" />
                <div className="text-xs font-semibold text-red-600 mt-1">{o.days_overdue} DAYS</div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
